<template>
  <div class="hm-transfer p10">
    <div class=" flex item-center flex-end">
      <el-select
        size="small"
        class="mr10"
        v-model="searchCondition.type"
        placeholder="请选择会员类型"
        @change="typeChange"
      >
        <el-option label="会员群组" value="group" v-show="showgroup"> </el-option>
        <el-option label="会员标签" value="label" v-show="showtap"> </el-option>
        <el-option label="会员电话" value="center" v-show="showtel"> </el-option>
      </el-select>
      <el-select
        style="width:500px"
        v-if="searchCondition.type === 'group'"
        size="small"
        class="mr10"
        v-model="searchCondition.value"
        placeholder="请选择会员群组"
        multiple
        filterable
        @change="changeSelect(searchCondition.value, 'memberGroupList')"
        @remove-tag="removeTag"
      >
        <el-option
          label="全选"
          value="all"
          @click.native="selectAll('memberGroupList')"
        ></el-option>
        <el-option
          :label="v.groupAppellation"
          :value="v.value"
          v-for="(v, i) in memberGroupList"
          :key="i"
        >
        </el-option>
      </el-select>

      <el-select
        style="width:500px"
        v-if="searchCondition.type === 'label'"
        size="small"
        class="mr10"
        v-model="searchCondition.value"
        placeholder="请选择会员标签"
        multiple
        filterable
        @change="changeSelect(searchCondition.value, 'memberLabelList')"
        @remove-tag="removeTag"
      >
        <el-option
          label="全选"
          value="all"
          @click.native="selectAll('memberLabelList')"
        ></el-option>
        <el-option
          :label="v.labelName"
          :value="v.value"
          v-for="(v, i) in memberLabelList"
          :key="i"
        >
        </el-option>
      </el-select>
      <el-input
        v-if="searchCondition.type === 'center'"
        clearable
        style="width:500px"
        v-model.trim="searchCondition.keyword"
        placeholder="请输入会员手机号"
        size="small"
        class="ipt mr10"
      ></el-input>

      <el-button type="primary" size="small" @click="search">添加</el-button>
    </div>
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1  text-center">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="leftName">待选会员</span>
          </div>
          <!-- <div class="transfer-title flex-2 text-center">可选范围</div> -->
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">会员类型</div>
          <div class="flex-1 name">类型内容</div>
          <div class="flex-1 name text-center">类型编码</div>
        </div>

        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="leftChecked"
              @change="handleLeftCheckedChange"
            >
              <div
                v-for="(v, i) in leftData"
                :key="i"
                class="check-wrapper flex item-center"
                :title="v.realname"
              >
                <div class="flex-4">
                  <el-checkbox :label="v" class="flex">
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'group'"
                      >会员群组</span
                    >
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'label'"
                      >会员标签</span
                    >
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'center'"
                      >会员</span
                    >

                    <el-tooltip :content="v.limitTypeName" placement="top">
                      <span class="flex-1 goods-name">{{
                        v.limitTypeName
                      }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.typeValue" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.typeValue
                      }}</span>
                    </el-tooltip>
                    <!-- <span
                      class="success flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'notStarted'"
                      >未开始</span
                    >
                    <span
                      class="danger flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'end'"
                      >已结束</span
                    >

                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span> -->
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
          <!-- <div class="hm-pagination">
            <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,  prev, pager, next, jumper"
              :current-page="currentPage"
            ></el-pagination>
          </div> -->
        </div>
      </div>
      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          v-model="isMustDelivery"
          v-if="showMustDelivery"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="必选"
          inactive-text="可选"
          inactive-value="no"
        >
        </el-switch> -->
        <el-switch
          size="mini"
          class="transfer-switch"
          v-model="listMode"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch>
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="leftData.length <= 0 || leftChecked.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="rightData.length <= 0 || rightChecked.length <= 0"
        ></el-button>
        <!-- <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="leftChecked.length <= 0 || rightData.length <= 0"
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button> -->
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1 text-center">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="rightName">已选会员</span>
          </div>
          <!-- <div class="transfer-title flex-2 text-center">已选范围</div> -->
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">会员类型</div>
          <div class="flex-1 name">类型内容</div>
          <div class="flex-1 name text-center">状态</div>
        </div>

        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="rightChecked"
              @change="handleRightCheckedChange"
            >
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper   item-center"
              >
                <!-- <div class="flex">
                  <el-checkbox :label="v" class="flex flex-3 item-center">
                    <el-tooltip :content="v.promotionName" placement="top">
                      <span class="flex-1 attrid">{{ v.promotionName }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-2 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                  </el-checkbox>
                </div> -->
                <div class="flex-4">
                  <el-checkbox :label="v" class="flex">
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'group'"
                      >会员群组</span
                    >
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'label'"
                      >会员标签</span
                    >
                    <span
                      class="flex-1 attrid"
                      v-if="v.memberLimitType === 'center'"
                      >会员</span
                    >

                    <el-tooltip :content="v.limitTypeName" placement="top">
                      <span class="flex-1 goods-name">{{
                        v.limitTypeName
                      }}</span>
                    </el-tooltip>
                    <div class="flex flex-1 flex-center item-center">
                      <span
                        v-if="v.listMode === 'white'"
                        class="select-type white"
                        >白</span
                      >
                      <span
                        v-if="v.listMode === 'black'"
                        class="select-type black"
                        >黑</span
                      >
                    </div>

                    <!-- <span
                      class="success flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'notStarted'"
                      >未开始</span
                    >
                    <span
                      class="danger flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'end'"
                      >已结束</span
                    >
                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span> -->
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
          <!-- <div class="hm-pagination" style="opacity:0">
            <el-pagination background></el-pagination>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div v-show="!notValid && rightData.length <= 0" class="error">
      请设置活动限制
    </div> -->
  </div>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
export default {
  props: {
    background: { type: String },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    transferMode: { type: String },
    isPreview: { type: Boolean },
    notValid: { type: Boolean },
    onlySelectOne: { type: Boolean },
    showgroup: { type: Boolean,default: true },
    showtap: { type: Boolean,default: true },
    showtel: { type: Boolean,default: true },
  },
  components: {},
  data() {
    return {
      listMode: "white",
      searchCondition: {
        type: "group",
        value: []
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      memberGroupList: [],
      memberLabelList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryMemberGroup();
    this.queryMemberLabel();
  },
  methods: {
    selectAll(list) {
      if (this.searchCondition.value.length < this[list].length) {
        this.searchCondition.value = [];
        this[list].map(item => {
          this.searchCondition.value.push(item.value);
        });
        this.searchCondition.value.unshift("all");
      } else {
        this.searchCondition.value = [];
      }
    },
    changeSelect(val, list) {
      if (!val.includes("all") && val.length === this[list].length) {
        this.searchCondition.value.unshift("all");
      } else if (val.includes("all") && val.length - 1 < this[list].length) {
        this.searchCondition.value = this.searchCondition.value.filter(item => {
          return item !== "all";
        });
      }
    },
    removeTag(val) {
      if (val === "all") {
        this.searchCondition.value = [];
      }
    },
    typeChange() {
      this.searchCondition.value = [];
    },
    async queryMemberGroup() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });
      result.records.forEach(v => {
        v.memberLimitType = "group";
        v.limitTypeName = v.groupAppellation;
        v.typeValue = v.groupId;
        v.value = JSON.stringify(v);
      });
      this.memberGroupList = result.records;
    },
    async queryMemberLabel() {
      const { result } = await this.$store.dispatch("queryLabelSystemList", {
        pageNo: 1,
        pageSize: 9999
      });
      result.records.forEach(v => {
        v.memberLimitType = "label";
        v.limitTypeName = v.labelName;
        v.typeValue = v.labelId;
        v.value = JSON.stringify(v);
      });
      this.memberLabelList = result.records;
    },
    paging(page) {
      this.currentPage = page;
      this.queryActivityList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryActivityList();
    },
    async queryActivityList() {
      let params = {
        // pageNo: this.currentPage,
        // pageSize: this.pageSize,
        keyword: this.searchCondition.keyword,
        queryType: "memberMobile"
      };

      //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      //   searchCondition.startDate =
      //     this.searchCondition.ruleValidDate &&
      //     this.searchCondition.ruleValidDate.length > 0
      //       ? this.searchCondition.ruleValidDate[0]
      //       : "";
      //   searchCondition.endDate =
      //     this.searchCondition.ruleValidDate &&
      //     this.searchCondition.ruleValidDate.length > 0
      //       ? this.searchCondition.ruleValidDate[1]
      //       : "";

      //   Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryMemberMgtList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.limitTypeName = v.memberName;
        v.typeValue = v.centerId;
        v.memberLimitType = "center";
      });

      this.leftData.push(...records);

      //   if (this.beltType === "promotion") {
      //   } else if (this.beltType === "coupon") {
      //     this.rightData.forEach(v => {
      //       this.leftData.forEach((item, index) => {
      //         if (v.ruleId === item.ruleId) {
      //           this.leftData.splice(index, 1);
      //         }
      //       });
      //     });
      //   }

      this.total = total;
    },
    search() {
      if (this.searchCondition.type !== "center") {
        if (this.searchCondition.value.length) {
          this.searchCondition.value.forEach(v => {
            if (v !== "all") {
              this.leftData.push(JSON.parse(v));
            }
          });
        }
      } else {
        this.currentPage = 1;
        this.queryActivityList();
      }
      this.leftData = arrayUnique2(this.leftData, "typeValue");
      this.rightData.forEach(v => {
        this.leftData.forEach((item, index) => {
          if (v.typeValue === item.typeValue) {
            this.leftData.splice(index, 1);
          }
        });
      });
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        this.leftData.forEach(v => {
          v.listMode = this.listMode;
        });

        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        this.leftData.forEach(v => {
          v.listMode = this.listMode;
        });

        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          //   this.rightData.forEach(v => {
          //     if (this.isMustDelivery) {
          //       v.isMustDelivery = this.isMustDelivery;
          //     }
          //   });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.typeValue === this.leftChecked[0].typeValue) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.typeValue === item.typeValue) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);

      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.typeValue === this.rightChecked[0].typeValue) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.typeValue === item.typeValue) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.typeValue) === String(item.typeValue)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    handleCheckChangeAttribute() {
      this.isCheckedAttribute =
        this.$refs.attributeTree.getCheckedNodes().length > 0;
    }
  }
};
</script>
<style lang="scss">
.hm-transfer {
  .table-body {
    .check-wrapper {
      padding-left: 12px;
    }
    .el-checkbox {
      width: 100%;
    }

    .el-checkbox__label {
      width: calc(100% - 24px);
      display: flex;
    }
    .check-wrapper:nth-child(even) {
      background: #f7f7f7;
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.leftName,
.rightName {
  margin-left: -52px;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 200px;
  margin: 0 1rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  //   max-width: 500px;
  width: 700px;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    .name {
      margin-left: -26px;
    }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 100px;
  }
}

.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}
</style>
